module.exports = __webpack_public_path__ + "img/klankenkaart.649b1326.png";